import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class CompetitionSeasonTopScorersDeleted extends DomainEvent<DeletedEntity> {}
